const Teams = {
  WHITE: 'white',
  BLACK: 'black',
}

export default Teams;